import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { PurchaseOrderService, ReportService } from "../../../services/index";

@Component({
  selector: "add-Core-Gang",
  templateUrl: "addCoreGang.html",
})
export class addCoreGang {
  row: any;
  data: any;
  qualityList: any;
  typeList: any;
  colorList: any;
  printData;
  codeList: any;
  widthList: any[];
  coreGangList = ["CORE", "GANG"];
  fitList = ["COMFORT FIT", "RELAX FIT", "SLIM FIT"];
  shirtStyleList = ["FORMAL", "CASUAL", "CLUB WEAR"];
  statusList = ["ACTIVE", "INACTIVE"];
  master = {
    party_design: "",
    party_shade: "",
    core_design: "",
    core_shade: "",
    fab_color: "",
    code: "",
    party_rate: "",
    width: "",
    fab_style: "",
    shirt_style: "",
    quality: "",
    brand: "",
    fit: "",
    mrp: "",
    booking_rate: "",
    wo_fcons: "",
    wo_hcons: "",
    type: "",
    party_id: "",
    core_designno: "",
    pshade: "",
    shade: "",
    pdesign_no: "",
    status: "",
  };

  acList: any = [];
  mode: string;
  saveEvent: any;
  partyCodeList: any;
  @Input() _params: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.saveEvent = val["data"].tabevent;
    let designData = Object.assign({}, val["data"]);
    if (this.mode == "Edit") {
      // this.designdata.po_date = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
      this.master.core_designno = designData.core_designno;
      this.master.shade = designData.shade;
      this.master.pshade = designData.pshade;
      this.master.pdesign_no = designData.pdesign_no;
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService,
    private reportService: ReportService
  ) {}
  ngOnInit() {
    this.codelist();
    this.colorlist();
    this.widthlist();
    this.typelist();
    this.qualitylist();
    this.tableScroll();
  }

  tableScroll() {
    $(".acbody").height(window.innerHeight - 600);
    $(".acbody").width(window.innerWidth - 30);
  }
  codelist() {
    this.poservice.codelist({}).then((res: any) => {
      this.codeList = res.data;
    });
  }
  colorlist() {
    this.poservice.colorlist({}).then((res: any) => {
      this.colorList = res.data;
    });
  }
  widthlist() {
    this.poservice.widthlist({}).then((res: any) => {
      this.widthList = res.data;
    });
  }
  qualitylist() {
    this.poservice.qualitylist({}).then((res: any) => {
      this.qualityList = res.data;
    });
  }

  typelist() {
    this.poservice.typelist({}).then((res: any) => {
      this.typeList = res.data;
    });
  }
  validateAddress() {
    let special = true;

    if (this.mode == "Add") {
      for (var key in this.master) {
        if (this.master[key].toString().match(/^[A-Za-z0-9\.\ ]+$/)) {
          special = false;
          swal("Special Characters are not allowed");
        }
      }
    } else {
      if (this.master.status == "") {
        special = false;
        swal("Please fill all fields");
      }
    }

    if (special == true) {
      this.submitCoreGang();
    } else {
      return false;
    }
  }
  submitCoreGang() {
    let params = {
      masterList: JSON.stringify(this.master),
      mode: this.mode,
    };

    this.reportService.submitCoreGang(params).then((res: any) => {
      if (res == true) {
        // this.resetform();
        if (this.mode == "Add") {
          swal(this.master.type + " Saved Successfully");
        } else {
          swal("Updated successfully");
        }
      } else {
        swal(
          "This design is already in" +
            this.master.type +
            ". Inactive it and save."
        );
      }
    });
  }
  resetform() {
    for (var key in this.master) {
      this.master[key] = "";
    }
  }
  onClickCode(party_code) {
    let partyCodeList = _.filter(this.codeList, { code: party_code });
    if (partyCodeList.length > 0) {
      this.partyCodeList = partyCodeList;
      this.master.party_id = this.partyCodeList[0]["party_id"];
    }
  }
  ngAfterViewInit() {
    if (this.mode == "Add") {
      setTimeout(() => {
        $("#party_design").focus();
      }, 100);
    }
  }
  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  saveEnabled() {
    let temp = true;

    if (this.mode == "Add") {
      for (var key in this.master) {
        if (key != "party_id") {
          if (!this.master[key]) {
            temp = false;
          }
        }
      }
    }
    return temp;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/coreGangMaster/addCoreGang.ts